import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
//
import { PublicClientApplication, EventType, EventMessage } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import App from './App';
// DataLagoon
import { DataLagoonProvider } from './DataLagoonContext';
import { msalConfig } from './authConfig';
import Me from './Me';
// ----------------------------------------------------------------------

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL and handle redirect promise to prevent stuck login modals
msalInstance.initialize().then(() => {
  // Handle redirect responses from B2C
  msalInstance.handleRedirectPromise()
    .then((response) => {
      if (response) {
        console.log('Redirect response handled successfully');
      }
    })
    .catch((error) => {
      console.error('Error handling redirect:', error);
    });

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

  // Track authentication events
  msalInstance.addEventCallback((message: EventMessage) => {
    if (message.eventType === EventType.LOGIN_SUCCESS) {
      console.log('Login successful');
    } else if (message.eventType === EventType.LOGIN_FAILURE) {
      console.error('Login failed:', message.error);
    } else if (message.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
      console.log('Token acquired successfully');
    } else if (message.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
      console.error('Token acquisition failed:', message.error);
    }
  });

  root.render(
    <HelmetProvider>
      <BrowserRouter>
        <Suspense>
          <MsalProvider instance={msalInstance}>
            <DataLagoonProvider>
              <Me />
              <App />
            </DataLagoonProvider>
          </MsalProvider>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}).catch((error) => {
  console.error('MSAL initialization failed:', error);
});
